<div class="slots-diagram-header">
  <h3>
    <a *ngIf="canBackwardDay" class="day-before" (click)="onPrevDay()">
      <fa-icon [icon]="faCaretLeft"></fa-icon>
    </a>
    <span class="day" (click)="selectDateClick()">{{ displaySelectedDate }}</span>
    <a class="day-after">
      <fa-icon [icon]="faCaretRight" (click)="onNextDay()"></fa-icon>
    </a>
  </h3>
  <hr>
</div>
